import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";

import {
  AddAsMemberButtonIcon,
  ChatMemberButtonIcon,
  EditGroupButtonIcon,
  ExitGroupMenuButtonIcon,
  GroupDotsIcon,
  GroupInfoButtonIcon,
  GroupInfoMenuButtonIcon,
  RemoveGroupMenuButtonIcon,
} from "../../assets/icons/MUI/GroupsIcons";
import { VerificationIcon } from "../../assets/icons/MUI/NetworkIcons";
import PlayerCoverImg from "../../assets/images/PlayerPreviewCover.png";
import ReviewedByAvatars from "../../assets/images/reviewed-by-avatars.jpg";
import { colors } from "../../theme/palette";
import { Chat, EndorsedSkill } from "../../types";
import SkillMeter from "../../shared/Entity/EntityEndorsedSkills/SkillMeter";

export const chats: Chat[] = [
  {
    id: "chat_1",
    createdAt: 1745320000000,
    counts: {
      "101": 2,
      "102": 0,
    },
    lastMessage: {
      createdAt: 1745320005000,
      type: "TEXT",
      data: {
        text: "Hello, how are you?",
        senderId: 101,
      },
      senderId: 101,
      uuid: "uuid-1",
    },
    participants: [101, 102],
    lastSeen: {
      "101": 1745320006000,
      "102": 1745320007000,
    },
    participantsNames: {
      "101": "Ali Hassan",
      "102": "Sarah Karim",
    },
  },
  {
    id: "chat_2",
    createdAt: 1745321000000,
    counts: {
      "103": 1,
      "104": 5,
    },
    lastMessage: {
      createdAt: 1745321010000,
      type: "TEXT",
      data: {
        text: "Don't forget our meeting tomorrow.",
        senderId: 104,
      },
      senderId: 104,
      uuid: "uuid-2",
    },
    participants: [103, 104],
    lastSeen: {
      "103": 1745321011000,
      "104": 1745321012000,
    },
    participantsNames: {
      "103": "Mona Salem",
      "104": "Ziad Elmasry",
    },
  },
  {
    id: "chat_3",
    createdAt: 1745322000000,
    counts: {
      "105": 0,
      "106": 3,
    },
    lastMessage: {
      createdAt: 1745322020000,
      type: "TEXT",
      data: {
        text: "I'll send the file soon.",
        senderId: 106,
      },
      senderId: 106,
      uuid: "uuid-3",
    },
    participants: [105, 106],
    lastSeen: {
      "105": 1745322021000,
      "106": 1745322022000,
    },
    participantsNames: {
      "105": "Youssef Maher",
      "106": "Hana Tarek",
    },
  },
];

const TestingGroupChat = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "15px",
        width: "866px",
        gap: "16px",
        minHeight: "calc(100vh - 100px)",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          background: colors.White,
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          width: "500px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <GroupHeader />
      </Box>
      <PlayerPreview />
      {/* <GroupPreview /> */}
    </Box>
  );
};

export default TestingGroupChat;

const GroupHeader = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const GroupHeaderMenuList = [
    {
      icon: <GroupInfoMenuButtonIcon />,
      label: "Group Info",
      onClickHandler: () => {
        handleClose();
      },
    },
    {
      icon: <GroupInfoMenuButtonIcon />,
      label: "Report Chat",
      onClickHandler: () => {
        handleClose();
      },
    },
    {
      icon: <RemoveGroupMenuButtonIcon />,
      label: "Remove Group",
      onClickHandler: () => {
        handleClose();
      },
    },
    {
      icon: <ExitGroupMenuButtonIcon />,
      label: "Exit Group",
      onClickHandler: () => {
        handleClose();
      },
    },
  ];

  return (
    <Box
      sx={{ padding: "20px 24px", borderBottom: "1px solid #E4E7EC", display: "flex", gap: "16px", position: "sticky" }}
    >
      <Box sx={{ width: "56px", height: "56px", bgcolor: "gray", borderRadius: "50%" }} />
      <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "344px" }}>
        <Typography
          sx={{
            color: "var(--Gray-900, #101828)",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          Group 1
        </Typography>
        <Typography
          sx={{
            overflow: "hidden",
            color: "var(--Gray-600, #475467)",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          Ahmed Ali, Layla Othman, Ahmed Mahmoud, Kareem Afify, Zainb Mostafa
        </Typography>
      </Box>
      <IconButton sx={{ padding: 0, height: "fit-content" }} onClick={handleClick}>
        <GroupDotsIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {GroupHeaderMenuList.map(({ icon, label, onClickHandler }) => (
          <MenuItem>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText onClick={onClickHandler}>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

const GroupPreview = () => {
  return (
    <Box
      sx={{
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        width: "350px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          borderBottom: "1px solid #EAECF0",
          padding: "24px 16px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
          <Button variant="text-md" startIcon={<GroupInfoButtonIcon />}>
            Group info
          </Button>
          <Button variant="text-md" startIcon={<EditGroupButtonIcon />}>
            Edit
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <Box sx={{ width: "96px", height: "96px", bgcolor: "gray", borderRadius: "50%" }} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                color: "var(--Gray-900, #101828)",
                fontFamily: "Montserrat",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "32px",
              }}
            >
              Group 1
            </Typography>
            <Typography
              sx={{
                color: "var(--Gray-600, #475467)",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
              }}
            >
              Group . 1,200 Members
            </Typography>
            <Typography
              sx={{
                color: "var(--Gray-600, #475467)",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
              }}
            >
              Public Group
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                color: "var(--Gray-700, #344054)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
              }}
            >
              Group Description
            </Typography>
            <Typography
              sx={{
                color: "var(--Gray-600, #475467)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              I'm a Product Designer based in Melbourne, Australia. I specialise in UX/UI design, brand strategy, and
              Webflow development.
            </Typography>
          </Box>
        </Box>
      </Box>
      <GroupPreviewMembersList />
    </Box>
  );
};

const GroupPreviewMembersList = () => {
  return (
    <Box sx={{ padding: "32px 16px", display: "flex", flexDirection: "column", gap: "24px" }}>
      <Typography
        sx={{
          color: "var(--colors-text-text-primary-900, #101828)",
          fontFamily: "Montserrat",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "28px",
        }}
      >
        Group Members (39)
      </Typography>
      {[...Array(6)].map((_, idx) => (
        <MemberCard key={idx} isLast={idx === 5} />
      ))}
    </Box>
  );
};

const MemberCard = ({ isLast }: { isLast: boolean }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "10px",
        alignItems: "flex-start",
        paddingBottom: isLast ? "" : "17px",
        borderBottom: isLast ? "" : "1px solid #EAECF0",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <VerificationIcon
          sx={{
            position: "absolute",
            top: "35px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: "10",
          }}
        />
        <Box sx={{ width: "49px", height: "49px", bgcolor: "gray", borderRadius: "50%" }} />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px", flex: 1 }}>
        <Link
          sx={{
            textDecoration: "none",
            color: colors.Dark1000,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            cursor: "pointer",
            lineHeight: "normal",
          }}
          onClick={() => {}}
        >
          Vitaly Goride
        </Link>
        <Typography
          component="span"
          variant="body12SemiBold"
          sx={{
            color: colors.Dark1000,
          }}
        >
          Agent . FC Zamalek
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="primary-md" startIcon={<AddAsMemberButtonIcon />}>
            Add as member
          </Button>
          <Button variant="outlined-md" startIcon={<ChatMemberButtonIcon />}>
            Chat
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const PlayerPreview = () => {
  const skills: EndorsedSkill[] = [
    { id: 1, title: "JavaScript", count: "24", percentage: 80 },
    { id: 2, title: "React", count: "18", percentage: 70 },
    { id: 3, title: "TypeScript", count: "15", percentage: 65 },
    { id: 4, title: "HTML5", count: "12", percentage: 60 },
    { id: 5, title: "CSS3", count: "11", percentage: 58 },
    { id: 6, title: "Node.js", count: "10", percentage: 55 },
    { id: 7, title: "Redux", count: "9", percentage: 50 },
    { id: 8, title: "Next.js", count: "7", percentage: 45 },
    { id: 9, title: "Git", count: "5", percentage: 40 },
    { id: 10, title: "REST APIs", count: "4", percentage: 38 },
    { id: 11, title: "Jest", count: "3", percentage: 30 },
    { id: 12, title: "Firebase", count: "2", percentage: 25 },
  ];

  const initialSkills = skills.slice(0, 4);
  const remainingSkills = skills.slice(4);

  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        width: "350px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          background: `url(${PlayerCoverImg})`,
          backgroundSize: "cover",
          height: "120px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            width: "96px",
            height: "96px",
            bgcolor: "gray",
            border: "4px solid var(--Base-White, #FFF)",
            borderRadius: "50%",
            position: "absolute",
            top: "84px",
            left: "12px",
          }}
        />
      </Box>
      <Box sx={{ padding: "88px 16px 24px", display: "flex", flexDirection: "column", gap: "24px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <Typography
            sx={{
              color: "var(--Gray-900, #101828)",
              fontFamily: "Montserrat",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "32px",
            }}
          >
            Mollie Hall
          </Typography>
          <Typography
            sx={{
              color: "var(--colors-text-text-tertiary-600, #475467)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
            }}
          >
            Agent . FC Zamalek
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px" }}>
          <Button variant="outlined-md" sx={{ flex: 1 }}>
            Message
          </Button>
          <Button variant="primary-md" sx={{ flex: 1 }}>
            View Profile
          </Button>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
            }}
          >
            Overview
          </Typography>
          <Typography
            sx={{
              color: "var(--Dark---1000, #111)",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            Driven and accomplished Football Coach with a proven track record of helping athletes achive their maximum
            level of athletic potential. Committed to fostering a positive team environment conducive to achieving
            success on the field.
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
            }}
          >
            Top Endorsed Skills
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                color: "var(--Dark---600, #707070)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Reviewed By
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={ReviewedByAvatars}
                style={{
                  width: "72px",
                  height: "24px",
                }}
              />
              <Typography
                sx={{
                  color: "var(--Dark---1000, #111)",
                  textAlign: "right",
                  fontFamily: "Montserrat",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                }}
              >
                +12
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              rowGap: "8px",
            }}
          >
            {initialSkills.map((skill, index) => (
              <SkillMeter key={index} skill={skill} />
            ))}
            {remainingSkills.length > 0 && (
              <>
                <Collapse in={expanded}>
                  {remainingSkills.map((skill, index) => (
                    <SkillMeter key={index + 4} skill={skill} />
                  ))}
                </Collapse>
                <Button
                  variant="text-sm"
                  fullWidth
                  onClick={handleExpandClick}
                  sx={{ marginTop: "17px", borderRadius: "4px" }}
                >
                  {expanded ? t("pages.entity.seeLess") : t("pages.entity.seeMore")}
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
